import { APP_CONFIG } from '@/constants/app';
import { unwrapApiData } from '@/utils/api-response';
import { tokenManager } from '@/utils/token-manager';
import axios from 'axios';

const adminApi = axios.create({
  baseURL: APP_CONFIG.api.baseUrl + '/admin',
  headers: { 'Content-Type': 'application/json' },
});

tokenManager.setupInterceptors(adminApi);

export interface AdminUser {
  uuid: string;
  email: string;
  role: string;
  firstName?: string;
  lastName?: string;
  isActive: boolean;
  lastLoginAt?: string | null;
  createdAt?: string;
}

export interface ImpersonateResponse {
  accessToken: string;
  expiresIn: number;
  user: { uuid: string; email: string; role: string };
}

// Le backend renvoie parfois { data: {...} } (TransformInterceptor) et parfois une liste paginée.
// On déballe défensivement pour récupérer le tableau d'utilisateurs.
function unwrapUsers(payload: unknown): AdminUser[] {
  const d = unwrapApiData<unknown>(payload);
  if (Array.isArray(d)) return d;
  if (typeof d !== 'object' || d === null) return [];

  const collection = d as {
    items?: AdminUser[];
    users?: AdminUser[];
    results?: AdminUser[];
  };
  return collection.items ?? collection.users ?? collection.results ?? [];
}

export const adminService = {
  getUsers: async (search?: string): Promise<AdminUser[]> => {
    const response = await adminApi.get('/users', {
      params: { limit: 500, ...(search ? { search } : {}) },
    });
    return unwrapUsers(response.data);
  },

  impersonate: async (uuid: string): Promise<ImpersonateResponse> => {
    const response = await adminApi.post(`/users/${uuid}/impersonate`);
    return unwrapApiData<ImpersonateResponse>(response.data);
  },
};
